import { render, staticRenderFns } from "./CopyTextButton.vue?vue&type=template&id=5af7916c&scoped=true"
import script from "./CopyTextButton.vue?vue&type=script&lang=js"
export * from "./CopyTextButton.vue?vue&type=script&lang=js"
import style0 from "./CopyTextButton.vue?vue&type=style&index=0&id=5af7916c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7916c",
  null
  
)

export default component.exports